import * as React from 'react';
export const crelanSvg = React.forwardRef(function crelanSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F2F2F2',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#00AE53',
        d: 'M7.25 17.07c0 1.12 7.61 4.48 7.61 5.6v5.6c0-1.12-7.61-4.48-7.61-5.6v-5.6z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#88C540',
        d: 'M8.34 9.23c0 1.12 6.52 4.48 6.52 5.6v5.6c0-1.12-6.52-4.48-6.52-5.6v-5.6z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#BDD753',
        d: 'M11.6 3.63c0 1.11 3.26 2.24 3.26 3.36v5.6c0-1.12-3.26-2.24-3.26-3.36v-5.6z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#00AE53',
        d: 'M24.65 17.07c0 1.12-7.61 4.48-7.61 5.6v5.6c0-1.12 7.61-4.48 7.61-5.6v-5.6z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#88C540',
        d: 'M23.56 9.23c0 1.12-6.52 4.48-6.52 5.6v5.6c0-1.12 6.52-4.48 6.52-5.6v-5.6z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#BDD753',
        d: 'M20.3 3.63c0 1.11-3.26 2.24-3.26 3.36v5.6c0-1.12 3.26-2.24 3.26-3.36v-5.6z',
      }),
    ),
  );
});
crelanSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var crelan = {
  category: 'brand',
  colorable: false,
  name: 'crelan',
  svg: crelanSvg,
};
